
import React from "react";
import styles from "../../assets/style.module.css";

export interface TagBadgeProps {
    className?: string;
    children: React.ReactNode;
}

function TagBadge({ children, className }: TagBadgeProps) {
    return (<span className={`${styles["badge"]}${className ? ` ${className}` : ""}`}>{children}</span>);
}

export default TagBadge;
